export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_UPDATE = 'USER_UPDATE';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const USER_NOTIFICATIONS = 'USER_NOTIFICATIONS';
export const CHANGE_VIEWMODE = 'CHANGE_VIEWMODE';
